import React, {useState, useRef, useEffect, useCallback} from 'react';
import {Helmet} from 'react-helmet';
import {Alert, Button} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {useHistory, Link} from "react-router-dom";
import {useTranslation} from 'react-i18next';
import Layout from '../common/Layout';
import LayoutContentContainer from '../common/LayoutContentContainer';
import useCreateClientStatusMessage from '../util/useCreateClientStatusMessage';
import useSubmitConfirmProviderApplication from '../providers/useSubmitConfirmProviderApplication';

const ConfirmProviderApplication = (props) => {
    const {t} = useTranslation();
    const history = useHistory();

    const isMounted = useRef(null);
    const createClientStatusMessage = useCreateClientStatusMessage();

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        }
    }, []);

    const submitConfirmProviderApplication = useSubmitConfirmProviderApplication();

    const confirmationId = props.location.pathname.split('/').slice(-1).pop()

    const [isLoadingSubmitConfirmApplication, setIsLoadingSubmitConfirmApplication] = useState(false);
    const [isLoadedSubmitConfirmApplication, setIsLoadedSubmitConfirmApplication] = useState(false);
    const [isErrorSubmitConfirmApplication, setIsErrorSubmitConfirmApplication] = useState(false);

    const [isNotFoundApplication, setIsNotFoundApplication] = useState(false);
    const [isExpiredApplication, setIsExpiredApplication] = useState(false);

    const handleSubmitConfirmProviderApplication = useCallback(
        async () => {
            setIsLoadingSubmitConfirmApplication(true);

            let response;
            try {
                response = await submitConfirmProviderApplication(confirmationId);
            } catch (error) {
                if (isMounted.current) {
                    console.log(response);
                    setIsErrorSubmitConfirmApplication(true);
                    createClientStatusMessage(error.createClientStatusMessage, true);
                    setIsLoadingSubmitConfirmApplication(false);
                }
                return
            }

            if (isMounted.current) {
                console.log(response);
                setIsLoadingSubmitConfirmApplication(false);
                setIsLoadedSubmitConfirmApplication(true);
                if (!response.activation) {
                    if (response.info === 'Activation link expired') {
                        setIsExpiredApplication(true);
                    } else {
                        setIsNotFoundApplication(true);
                    }
                }
            }
        },
        [
            setIsLoadingSubmitConfirmApplication,
            submitConfirmProviderApplication,
            setIsErrorSubmitConfirmApplication,
            createClientStatusMessage,
            confirmationId
        ]
    );

    useEffect(
        () => {
            if (
                !isLoadedSubmitConfirmApplication &&
                !isLoadingSubmitConfirmApplication &&
                !isErrorSubmitConfirmApplication
            ) {
                handleSubmitConfirmProviderApplication();
            }
        },
        [
            isLoadingSubmitConfirmApplication,
            isLoadedSubmitConfirmApplication,
            isErrorSubmitConfirmApplication,
            handleSubmitConfirmProviderApplication
        ]
    );

    useEffect(
        () => {
            if (isNotFoundApplication) {
                history.push('/')
            }
        },
        [
            isNotFoundApplication, history
        ]
    );

    return <>
        {
            <Layout navSecondaryShow={true} className="bg-light" contentBackgroundArt={true}>
                <Helmet><title>{t('ConfirmProviderApplication.page-head-title')}</title></Helmet>
                {isLoadedSubmitConfirmApplication && !isNotFoundApplication && !isExpiredApplication ?
                    <>
                        <LayoutContentContainer
                            style={
                                {
                                    maxWidth: '50rem'
                                }
                            }
                        >
                            <Alert variant="success">
                                <p><strong>{t('ConfirmProviderApplication.message-submit-success.p1')}</strong></p>
                                <p className="mb-0">{t('ConfirmProviderApplication.message-submit-success.p2')}</p>
                            </Alert>
                            <Alert variant="info">
                                <p className="mb-0">{t('ConfirmProviderApplication.message-submit-success.p3')}<LinkContainer to="/contact-us"><Link to='/contact'>{t('ConfirmProviderApplication.message-submit-success.p4')}</Link></LinkContainer>{t('ConfirmProviderApplication.message-submit-success.p5')}</p>
                            </Alert>
                            <div style={{display: 'flex', marginTop: '2rem'}}>
                                <LinkContainer to="/" exact={true}>
                                    <Button
                                        className="ml-auto"
                                    >{t('ConfirmProviderApplication.go-to-home')}</Button>
                                </LinkContainer>
                            </div>
                        </LayoutContentContainer>
                    </> :
                    isLoadedSubmitConfirmApplication && isExpiredApplication ?
                        <>
                            <LayoutContentContainer
                                style={
                                    {
                                        maxWidth: '50rem'
                                    }
                                }
                            >
                                <Alert className="mb-0" variant="warning">
                                    <p className="mb-0">{t('ConfirmProviderApplication.message-confirmation-expired')}</p>
                                </Alert>
                                <div style={{display: 'flex', marginTop: '2rem'}}>
                                    <LinkContainer to="/" exact={true}>
                                        <Button
                                            className="ml-auto"
                                        >{t('ConfirmProviderApplication.go-to-home')}</Button>
                                    </LinkContainer>
                                </div>
                            </LayoutContentContainer>
                        </> :
                        null
                }
            </Layout>
        }
    </>
}

export default ConfirmProviderApplication;
